import { useForm } from 'react-hook-form';
import { RenderForm } from '../../../components/forms';
import { FORM_POLICY_MODAL } from '../form';
import { ButtonTheme } from '../../../components/buttons';
import { ContainerButton } from '../../../styles/global-style';
import React, { useEffect, useRef } from 'react';
import { ModalTheme } from '../../../components/modal';
import { TextLarge } from '../../../components/text';
import { useGetPdpaData } from '../hooks/useGetPdpaData';
export const PolicyModal = ({ open, onToggle, onAccept }) => {
  const isMounted = useRef(false);
  const { control, setValue, getValues, watch } = useForm();
  const isChecked = watch('checkPolicy');

  const { mutate: fetchPdpaData } = useGetPdpaData({
    onSuccess: (result) => {
      if (result?.item?.policyText) {
        setValue('policyText', result.item.policyText);
      }
    },
  });

  useEffect(() => {
    isMounted.current = true;
    if (open) {
      fetchPdpaData();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open, fetchPdpaData]);

  const handleAccept = () => {
    if (isChecked) {
      onAccept();
    }
  };

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle} hideClose>
      <TextLarge text="นโยบายและเงื่อนไขการให้บริการ" />
      <RenderForm
        control={control}
        setValue={setValue}
        getValues={getValues}
        forms={FORM_POLICY_MODAL()}
      />
      <ContainerButton center>
        <ButtonTheme useFor="CONFIRM" onClick={handleAccept} disabled={!isChecked} />
      </ContainerButton>
    </ModalTheme>
  );
};
